import React, { useContext } from 'react'
import { Icon } from 'semantic-ui-react'
// import DeleteIcon from '../deleteIcon'
import { InvoiceToggleContext } from './AccordianInvoice'

const ToggleInvoices =(props) =>{
  const {
    lineNumber,
    isActive,
    onClick,
    titleValue,
    onDelete,
    expandCollapseId,
    deleteItemId,
    containerStyle={},
    titleWidthClass="width20",
    stepNumberClass="stepNumber",
    title,
    activeIcon="minus circle",
    inactiveIcon="plus circle",
    iconClass="",
    titleValueContainer="titleValue",
    showDeleteIcon=true,
    confirmationMsg,
    sequenceNumeric,
    titleAlwaysShow=false,
    markDeletedUI,
    insertUpdateUI,
    toggleId,
    
  } = props
  const deleteHandle = () => {
    if (!window.confirm(`Are you sure ? Remove ${confirmationMsg} ` + counter))
    return
    onDelete()
  }

  let isToggleActive 
  const toggleContext =useContext(InvoiceToggleContext)
  if(toggleContext){
    isToggleActive = toggleContext.state?.[`${toggleId}`] 
  }else{
  isToggleActive = isActive
  }
 

  let counter = lineNumber < 10 ? `00${lineNumber}` : lineNumber < 99 ? `0${lineNumber}` : lineNumber
  return (
    <div className='EUStatusDetail'>
      <div className='title' style={{...containerStyle}}>
        <div id={expandCollapseId} className='belowTitleClass' style={{flex:isToggleActive? 1:.4}}>
        <div style={{height:'fit-content'}} id={(isToggleActive?'active-':'inActive-')+expandCollapseId} className={stepNumberClass}
         onClick={()=>{
          if(typeof onClick === 'function'){
            onClick()
          }else{
            toggleContext.dispatch({type:"TOGGLE_BY_ID",toggleId})
          }
        }}
         >
          <Icon className={iconClass} name={isToggleActive ? activeIcon : inactiveIcon} />
          <span>{counter}</span> {' '}
        </div>
        {sequenceNumeric &&
        <div style={{height:'fit-content'}} className='stepNumber sequenceNumeric'>
        <span>SEQ-{sequenceNumeric}</span>
        </div>
        }
         <span style={{alignSelf:'center'}} className='markedDeletespan'>
          {/* {isToggleActive && !markDeletedUI && !insertUpdateUI&& showDeleteIcon && <DeleteIcon id={deleteItemId} onClick={deleteHandle} />} */}
          {isToggleActive && markDeletedUI && markDeletedUI() }
          {isToggleActive && insertUpdateUI && insertUpdateUI() }

       </span>
        </div>
        <div className={titleValueContainer}>
            {isToggleActive && (  <div
                  className='activeTitle'
                >
                  <strong>{title}</strong>
                </div>) }
          <div>{(!isToggleActive || titleAlwaysShow) &&  titleValue && titleValue }</div>
        </div>
      </div>
    </div>
  )
}
export default React.memo(ToggleInvoices)